import axios from 'axios';

// Catálogo SEPOMEX de México (32 estados, municipios y colonias) publicado en el
// CDN por pawer-backend (scripts/geo/build-mexico-geo.js). Es estático: se cachea
// en memoria por sesión. Los archivos son públicos, no llevan token.
const cache = { estados: null, colonias: {} };

const geoUrl = () => process.env.VUE_APP_MX_GEO_URL;

export default class MexicoGeoService {
  // [{ codigo: '01', nombre, municipios: [{ codigo: '01001', nombre }] }]
  static async getEstados() {
    if (cache.estados) return { status: 'ok', data: cache.estados };
    if (!geoUrl()) {
      console.error('VUE_APP_MX_GEO_URL no está configurada');
      return { status: 'error' };
    }
    try {
      const response = await axios.get(`${geoUrl()}/estados-municipios.json`);
      cache.estados = response.data.estados;
      return { status: 'ok', data: cache.estados };
    } catch (error) {
      console.error('No se pudo cargar el catálogo de estados de México', error);
      return { status: 'error' };
    }
  }

  // [{ nombre, tipo, codigosPostales: ['20000'] }] del municipio (código de 5 dígitos).
  static async getColonias(municipioCode) {
    if (cache.colonias[municipioCode]) return { status: 'ok', data: cache.colonias[municipioCode] };
    if (!geoUrl()) {
      console.error('VUE_APP_MX_GEO_URL no está configurada');
      return { status: 'error' };
    }
    try {
      const response = await axios.get(`${geoUrl()}/colonias/${municipioCode}.json`);
      cache.colonias[municipioCode] = response.data.colonias;
      return { status: 'ok', data: cache.colonias[municipioCode] };
    } catch (error) {
      console.error(`No se pudo cargar las colonias del municipio ${municipioCode}`, error);
      return { status: 'error' };
    }
  }
}
